import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

interface InitialState {
  parent_createFreeReservationData: any;
  parent_createFreeReservationLoading: boolean;
  parent_createFreeReservationError: SerializedError | null;
}

const initialState: InitialState = {
  parent_createFreeReservationData: {},
  parent_createFreeReservationLoading: false,
  parent_createFreeReservationError: null,
};

interface IParentCreateFreeReservationInput {
  activityId: string;
  accessToken: string;
}

export const parent_createFreeReservationFunc = createAsyncThunk(
  'parent_createFreeReservation/parent_createFreeReservationFunc',
  async (values: IParentCreateFreeReservationInput) => {
    const data1 = JSON.stringify({
      query: `mutation Mutation($reservationInput: ReservationInput!) {
        parent_createFreeReservation(reservationInput: $reservationInput) {
          _id
        }
      }`,
      variables: {
        reservationInput: {
          activity: {
            _id: values.activityId,
          },
          imageUrl: ' ',
        },
      },
    });

    const config = initialConfig(
      'https://api.hophop.com.tr/activity/graphql',
      data1,
      values.accessToken
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parent_createFreeReservation = createSlice({
  name: 'parent_createFreeReservation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(parent_createFreeReservationFunc.pending, (state) => {
      state.parent_createFreeReservationLoading = true;
    });
    builder.addCase(parent_createFreeReservationFunc.fulfilled, (state, action) => {
      state.parent_createFreeReservationLoading = false;
      state.parent_createFreeReservationData = action.payload.data?.parent_createFreeReservation;
      state.parent_createFreeReservationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parent_createFreeReservationFunc.rejected, (state, action) => {
      state.parent_createFreeReservationLoading = false;
      state.parent_createFreeReservationError = action.error;
    });
  },
});

export default parent_createFreeReservation.reducer;
